import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-18 min-h-[70vh] flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <h1 className="text-6xl md:text-8xl font-heading font-bold text-primary-500 mb-4">
            404
          </h1>
          <h2 className="text-lg md:text-xl font-semibold text-foreground-900 mb-2">
            页面未找到
          </h2>
          <p className="text-sm text-foreground-600 mb-6 max-w-sm mx-auto">
            你访问的页面可能已被移除或链接不正确，返回首页探索更多美丽内容吧。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-arrow-left-line" />
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}